export const yellowDarker = '#604C06';
export const yellowDark = '#BF970D';
export const yellow = '#F0C01A';
export const yellowLight = '#F6DA79';
export const yellowLighter = '#FAEBB7';
export const yellowLightest = '#FDF8E7';
export const orangeDarker = '#543417';
export const orangeDark = '#794B20';
export const orange = '#D06D01';
export const orangeLight = '#FBB856';
export const orangeLighter = '#FCD59C';
export const orangeLightest = '#FEF5E6';
export const roseDarker = '#482632';
export const roseDark = '#922B4F';
export const rose = '#CF5E86';
export const roseLight = '#D695AB';
export const roseLighter = '#FBC1D6';
export const roseLightest = '#FEECF2';
export const chestnutDarker = '#500101';
export const chestnutDark = '#AA3131';
export const chestnut = '#C84E4E';
export const chestnutLight = '#DC8484';
export const chestnutLighter = '#E7ACAC';
export const chestnutLightest = '#FAEFEF';
export const jazzberryDarker = '#5D2747';
export const jazzberryDark = '#8C3468';
export const jazzberry = '#B44B89';
export const jazzberryLight = '#D090B6';
export const jazzberryLighter = '#EDD4E3';
export const jazzberryLightest = '#FEFDFD';
export const javaDarker = '#4D3055';
export const javaDark = '#6D4479';
export const java = '#A05FA2';
export const javaLight = '#BE91BF';
export const javaLighter = '#D9BFD9';
export const javaLightest = '#F4EFF6';
export const kimberlyDarker = '#403758';
export const kimberlyDark = '#4F456E';
export const kimberly = '#7C6AB1';
export const kimberlyLight = '#A49BC0';
export const kimberlyLighter = '#CCC7DC';
export const kimberlyLightest = '#F1EFF5';
export const blueDarker = '#121B36';
export const blueDark = '#1F2C4F';
export const blue = '#384B7D';
export const blueLagoon = '#017F86';
export const blueLight = '#4462B1';
export const blueLighter = '#8496C7';
export const blueLightest = '#DCE1EF';
export const azureDarker = '#103546';
export const azureDark = '#295461';
export const azure = '#53AEC9';
export const azureLight = '#93CADC';
export const azureLighter = '#C5E3EC';
export const azureLightest = '#ECF6F9';
export const pineDarker = '#0D3A32';
export const pineDark = '#016060';
export const pine = '#1F8573';
export const pineLight = '#46A594';
export const pineLighter = '#6FBDA1';
export const pineLightest = '#EEFBF9';
export const seaFoamDark = '#26B079';
export const Apple = '#509E2E';
export const graniteGray = '#79766E';
export const codGray = '#1D1D1D';
export const shineWhite = '#E4F7F6';
export const blueShine = '#116963';
export const whiteSine = '#FAFAFA';
export const mineShaft = '#3D3D3D';
export const alto = '#5E5E5E';
export const gallery = '#EBEBEB';
export const pearl = '#F8F8F8';
export const salmonPink = '#FA8E8E';
export const darkRed = '#7F241F';
export const wineRed = '#BB0D0D';
export const pearlWhite = '#FCF6F3';
export const pearlGreen = '#E0FAEB';
export const green = '#56C281';
export const orangeRed = '#B5470D';
export const skyblue = '#A8CEEB';
// Pie Chart
export const magenta = '#F78DB9';
export const disco = '#8C1245';
export const redViolet = '#CC1A64';
export const toryBlue = '#114597';
export const denim = '#1D5BBF';
export const malibu = '#85B2FA';
export const eden = '#0D544F';
export const genoa = '#137770';
export const puertoRico = '#45BFB7';
export const daisyBush = '#632B9C';
export const fuchsiaBlue = '#7D3CBE';
export const perfume = '#C79CF2';
export const blueHaze = '#C8D0E0';
export const cyanBlue = '#EEF4FC';
export const violet = '#703793';
export const blue500 = '#3b82f6';
// export const greenLightest = '#22C55E';
